export default __webpack_public_path__ + "static/media/vaccine-dose-enabled.0f5391ed.svg";